import GoogleMapsLoader from "google-maps";
import {mapGetters} from "vuex";

export const baseSearchMapMixin = {
    data() {
        return {
            google: null,
            map: null,
            markers: [],
            pointOfRef: null,
            widgetReady: false,
        }
    },
    computed: {
        ...mapGetters(["searchCriteria", "paginatedResults"])
    },
    watch: {
        searchCriteria(newValue) {
            this.loadCoordinates();
        },
        paginatedResults() {
            this.initMarkers();
        }
    },
    methods: {
        async baseInit() {
            this.initMap();
            this.addBusEvents();
        },
        async continueInit() {
            this.widgetReady = true;
            await this.$nextTick();
            this.map = new this.google.maps.Map(this.$refs.map, {
                zoom: 11,
                scrollwheel: false,
                zoomControl: true
            });
            this.loadCoordinates();
            this.initMarkers();
        },
        initMap() {
            GoogleMapsLoader.KEY = 'AIzaSyBULgN2oWltDQFqUfdnoAFSg76UcLTbvvM';
            GoogleMapsLoader.LIBRARIES = ['places'];
            GoogleMapsLoader.VERSION = '';
            let self = this;
            GoogleMapsLoader.load(function (google) {
                self.google = google;
                self.continueInit();
            });
        },
        loadCoordinates() {
            this.centerMap(this.searchCriteria.latitude, this.searchCriteria.longitude);
            this.setPointOfReference(this.searchCriteria.latitude, this.searchCriteria.longitude);
        },
        centerMap(latitude, longitude) {
            //console.log("centering map: latitude:", latitude, " longitude:", longitude);
            let center = new this.google.maps.LatLng(latitude, longitude);
            this.map.setCenter(center);
        },
        setPointOfReference(latitude, longitude) {
            //console.log('setting point of reference, latitude:', latitude, ' longitude:', longitude);
            if (this.pointOfRef != null) {
                this.pointOfRef.setMap(null);
                this.pointOfRef = null;
            }
            this.pointOfRef = new this.google.maps.Marker({
                map: this.map,
                draggable: false,
                position: new this.google.maps.LatLng(latitude, longitude),
                title: "Current Location"
            });
        },
        getCustomMarker(color, strokeColor) {
            return {
                path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z',
                fillColor: color,
                fillOpacity: 1,
                strokeColor: strokeColor,
                strokeWeight: 2,
                scale: 1
            };
        },
        addBusEvents() {
            this.$bus.$on(this.$AcEvents.LOCATE_IN_MAP, this.locateInMap);
        },
        locateInMap({latitude, longitude}) {
            this.centerMap(latitude, longitude);
            this.highlightMarker({latitude, longitude}, true);
        },
        initMarkers() {
            //clear all markers
            for (let i = 0; i < this.markers.length; i++) {
                this.markers[i].setMap(null);
            }
            this.markers = [];
            if (this.paginatedResults.length == 0) {
                return
            }
            this.markers = [];
            let self = this;
            for (let i = 0; i < this.paginatedResults.length; i++) {
                let current = this.paginatedResults[i];
                //Check if we already have this location, multiple providers can have the same address
                let markerMatch = $.grep(this.markers, function (element) {
                    return current.latitude === element.originalLatitude &&
                        current.longitude === element.originalLongitude;
                });
                //console.log('current: ', current, ' match:', markerMatch);
                if (markerMatch.length == 0) {
                    let point = new this.google.maps.LatLng(current.latitude, current.longitude);
                    let marker = new this.google.maps.Marker({
                        map: self.map,
                        draggable: false,
                        position: point,
                        title: current.name,
                        originalLatitude: current.latitude,
                        originalLongitude: current.longitude,
                        icon: self.getCustomMarker('rgb(0,155,222)', 'rgb(1, 139, 198)')
                    });
                    this.markers.push(marker);
                    this.google.maps.event.addListener(marker, 'click', function (target, elem) {
                        let markerthis = this;
                        let coordinates = {latitude: markerthis.originalLatitude, longitude: markerthis.originalLongitude};
                        self.$bus.$emit(self.$bus.$AcEvents.HIGHLIGHT_COORDINATES_IN_LIST, coordinates);
                        //postbox.publish('HIGHLIGHT_COORDINATES_IN_LIST', coordinates);
                        self.highlightMarker(coordinates, false);
                    });
                } else {
                    //console.log('Multiple providers with same latitude and longitude');
                    markerMatch[0].title = "Multiple providers";
                }
            }
        },
        highlightMarker(data, bounce) {
            let markerMatch = null;
            for (let i = 0; i < this.markers.length; i++) {
                let currentMarker = this.markers[i];
                if (currentMarker.originalLatitude !== data.latitude && currentMarker.originalLongitude !== data.longitude) {
                    currentMarker.setOpacity(0.5);
                } else {
                    markerMatch = currentMarker;
                }
            }
            if (markerMatch != null) {
                markerMatch.setOpacity(1);
                if (bounce) {
                    markerMatch.setAnimation(this.google.maps.Animation.BOUNCE);
                    setTimeout(function () {
                        markerMatch.setAnimation(null);
                    }, 700);
                }

            }
        }
    }
};